import { render } from "./SettingsPage.vue?vue&type=template&id=2e40ad5c&scoped=true&ts=true"
import script from "./SettingsPage.vue?vue&type=script&lang=ts"
export * from "./SettingsPage.vue?vue&type=script&lang=ts"

import "./SettingsPage.vue?vue&type=style&index=0&id=2e40ad5c&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e40ad5c"]])

export default __exports__